// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

/**
 * Creates a method that deprecates or replaces deprecated props on
 * an object.
 * @param {Function} deprecateMethod The handler for deprecating a prop
 * @returns {Function}
 */
const createDeprecatedFieldsMethod = deprecateMethod => options => {
  var { deprecatedFieldsToNewFieldsMap, data } = options
  for (const deprecatedFieldName in deprecatedFieldsToNewFieldsMap) {
    const newFieldName = deprecatedFieldsToNewFieldsMap[deprecatedFieldName]
    data = deprecateMethod({
      obj: data,
      newPropName: newFieldName,
      propName: deprecatedFieldName,
    })
  }
  return data
}

/**
 * Replace a field on an object, and warn that it is deprecated
 * @param {object} options.obj
 * @param {string} options.propName
 * @param {string} options.oldPropName
 * @returns {object}
 */
export const replaceDeprecatedField = params => {
  var { obj, newPropName, propName } = params
  if (propName in obj == false) return obj
  // Make the warning a proper error so we have a stack trace which will
  // greatly help tracking down where deprecated props are being used.
  var warning = new Error(
    `${propName} is deprecated, use ${newPropName} instead.`,
  )
  //eslint-disable-next-line
  console.warn(warning)
  obj = { ...obj }
  obj[newPropName] = obj[propName]
  delete obj[propName]
  return obj
}

/**
 * Add a deprecated prop value on an object, and warn whenever that deprecated
 * prop is used.
 * @param {object} options.obj
 * @param {string} options.propName
 * @param {string} options.oldPropName
 * @returns {object}
 */
export const addDeprecatedField = options => {
  var { obj, newPropName, propName } = options
  obj = { ...obj }
  if (newPropName in obj == false)
    throw new Error(
      `Deprecating prop '${propName}' in
      favour for '${newPropName}' but it has no value where as '${propName}' does.
      Perhaps call replaceDeprecatedFields first.`.replace(/\s+/g, ' '),
    )
  var realValue = obj[newPropName]
  Object.defineProperty(obj, propName, {
    configurable: false,
    enumerable: true,
    get() {
      var warn = new Error(
        'The prop ' +
          propName +
          ' is deprecated use ' +
          newPropName +
          ' instead.',
      )
      // eslint-disable-next-line
      console.warn(warn)
      return realValue
    },
  })
  return obj
}

/**
 * Accepts a mission object and replaces any deprecated fields with what they
 * should be.
 * @param {object} options.deprecatedFieldsToNewFieldsMap A key value map where
 * the key is the deprecated prop name and the value is what the new prop name
 * should be
 * @param {object} options.data The mission object
 * @returns {object} A new mission object with corrected prop names.
 */
export const replaceDeprecatedFields = createDeprecatedFieldsMethod(
  replaceDeprecatedField,
)

/**
 * Adds deprecated prop values to fields and warns about their use. So that
 * code that depends on deprecated values still works.
 * @param {object} options.deprecatedFieldsToNewFieldsMap A key value map where
 * the key is the deprecated prop name and the value is what the new prop name
 * should be
 * @param {object} options.data The mission object
 * @returns {object} A new mission object with the added deprecated prop names.
 */
export const addDeprecatedFields = createDeprecatedFieldsMethod(
  addDeprecatedField,
)



// WEBPACK FOOTER //
// ./src/shared/misc.js